export var PaymentPurchaseErrorEnum;
(function (PaymentPurchaseErrorEnum) {
    PaymentPurchaseErrorEnum["RedemptionFailure"] = "RedemptionFailure";
    PaymentPurchaseErrorEnum["CardDeclined"] = "CardDeclined";
})(PaymentPurchaseErrorEnum || (PaymentPurchaseErrorEnum = {}));
export var GeneralPurchaseErrorEnum;
(function (GeneralPurchaseErrorEnum) {
    GeneralPurchaseErrorEnum["NoAvailability"] = "NoAvailability";
    GeneralPurchaseErrorEnum["FraudAutoReject"] = "FraudAutoReject";
    GeneralPurchaseErrorEnum["InvalidSession"] = "InvalidSession";
    GeneralPurchaseErrorEnum["InActivity"] = "Inactivity";
    GeneralPurchaseErrorEnum["LikelyFraud"] = "LikelyFraud";
    GeneralPurchaseErrorEnum["AuthError"] = "AuthError";
    GeneralPurchaseErrorEnum["CartValidationError"] = "CartValidationError";
    GeneralPurchaseErrorEnum["ExpiredFulfillToken"] = "ExpiredFulfillToken";
    GeneralPurchaseErrorEnum["ExpiredQuoteToken"] = "ExpiredQuoteToken";
    GeneralPurchaseErrorEnum["ErrorCode"] = "ErrorCode";
})(GeneralPurchaseErrorEnum || (GeneralPurchaseErrorEnum = {}));
//# sourceMappingURL=purchase-errors.js.map